import formatIdentifierAsString from "../../../functions/formatIdentifierAsString.function";

export default formatIdentifierAsString;
